export const LANGUAGE = {
    english: 'en' as const,
    italian: 'it' as const,
} as const;

export type Language = (typeof LANGUAGE)[keyof typeof LANGUAGE];
